import { render } from "./LocationsPage.vue?vue&type=template&id=c231e5b6&ts=true"
import script from "./LocationsPage.vue?vue&type=script&lang=ts"
export * from "./LocationsPage.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./LocationsPage.vue?vue&type=style&index=0&id=c231e5b6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__